<template>
  <InputContainer :textLabel="textLabel" :hasError="hasError && required">
    <input
      type="date"
      v-model="localInputValue"
      :class="{ disabled: isDisabled && inputValue === null }"
      :max="new Date().toLocaleDateString('en-CA')"
      :readonly="readonly ? true : null"
      :disabled="isDisabled"
      @keyup="handleKeyup()"
      @focus="
        handleFocus();
        hideCheckout();
      "
      @blur="
        handleBlur();
        showCheckout();
      "
    />
  </InputContainer>
</template>

<script>
import moment from 'moment';
import validateText from '@/helpers/validateText.js';
import InputContainer from '@/components/input/InputContainer.vue';
import toggleCheckout from '@/mixins/toggleCheckout.js';

export default {
  name: 'DateInput',
  mixins: [toggleCheckout],
  data() {
    return {
      hasError: false,
      localInputValue: this.inputValue,
    };
  },
  components: {
    InputContainer,
  },
  props: {
    textLabel: {
      type: String,
      require: true,
    },
    inputValue: {
      type: String,
      require: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    validateBirth: {
      type: Boolean,
      default: true,
    },
    readonly: Boolean,
    validateField: Boolean,
    regexString: String,
    isDisabled: Boolean,
  },
  watch: {
    inputValue(value) {
      this.localInputValue = value;
    },
    validateField(value) {
      if (value) {
        const status = this.validate();

        this.hasError = !status;

        this.$emit('validateField', status);
        return status;
      }
    },
  },
  methods: {
    handleFocus() {
      if (this.readonly) return false;

      this.hasError = false;
    },
    handleBlur() {
      if (this.readonly) return false;

      this.$emit('update:inputValue', this.localInputValue);

      const response = this.validate(this.localInputValue);

      this.hasError = !response;

      this.$emit('validateField', this.validate());
    },
    validate() {
      let regex = /^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/;

      if (!this.required) {
        return true;
      }

      if (!this.validateBirth) {
        return true;
      }

      if (!validateText(this.localInputValue, regex)) return false;

      moment.locale('pt-BR');

      const birthDate = moment(this.localInputValue);
      const maxDate = moment().subtract(18, 'years');
      const minDate = moment().subtract(115, 'years');

      if (!birthDate.isBetween(minDate, maxDate)) {
        return false;
      }

      return true;
    },
    handleKeyup() {
      if (this.readonly) return false;

      this.$emit('update:inputValue', this.localInputValue);
    },
  },
};
</script>

<style lang="scss" scoped>
input {
  max-height: 1.8125rem;

  &[disabled] {
    max-height: 1.3125rem;
  }

  &.disabled {
    color: var(--placeholder-color) !important;
  }
}
</style>